import React, { FC, memo } from "react";
import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  className?: string;
  height?: string;
  strokeColor?: string;
  width?: string;
}

const PreviewMobile: FC<Props> = ({
  className,
  height = "1.5rem",
  strokeColor = colors.lapel,
  width = "1.5rem",
}) => (
  <Svg
    className={className}
    height={height}
    viewBox="0 0 24 24"
    width={width}
    title="edit"
  >
    <path d="M16.5 2.1h-9c-.8 0-1.5.7-1.5 1.5v17c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5ZM7 6.1h10v12H7v-12Zm.5-3h9c.3 0 .5.2.5.5v1.5H7V3.6c0-.3.2-.5.5-.5Zm9 18h-9c-.3 0-.5-.2-.5-.5v-1.5h10v1.5c0 .3-.2.5-.5.5Z" fill={strokeColor} />
  </Svg>
);

export default memo(PreviewMobile);
